/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleSubmissionState } from './moduleSubmissionState';

export type SubmissionRecordState = ModuleSubmissionState | null;
